import DataTile from "./DataTile";
import PeopleAltSharpIcon from '@material-ui/icons/PeopleAltSharp';
import { fetchUsers} from "../../../actions";
import React from "react";
import {filterObject} from "../../../util/bbHelpers";

const Tile = (props) => {
    return (
        <DataTile
            color="primary"
            subTitle="Active Users"
            icon={<PeopleAltSharpIcon style={{fontSize: "70px"}}/>}
            stateName="users"
            stateElement="users"
            stateLoaderName="loadingUsers"
            stateLoaderError="loadingUsersError"
            stateFetchAction={fetchUsers()}
            valueFunction={(stateData) => stateData ? Object.keys(filterObject(stateData, (_, stateData) => stateData.is_active)).length : null}
        />
        )
}

export default Tile;